import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { forkJoin, map } from 'rxjs';
import { environment } from 'src/environments/environment';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@Injectable()
export class CustomTranslateLoaderService extends TranslateHttpLoader {
  langs = [
    { key: 'en-GB', name: 'English', shortKey: 'en' },
    { key: 'es-ES', name: 'Spanish', shortKey: 'es' },
  ];

  constructor(http: HttpClient, private httpClient: HttpClient) {
    super(http, 'assets/i18n/', '.json');
  }

  getTranslation(lang: string) {
    return forkJoin([this.getAppTranslations(lang), this.getNgxMessagingTranslations(lang)]).pipe(
      map((res) => {
        return { ...res[0], ...res[1] };
      })
    );
  }

  getAppTranslations(lang: string) {
    return super.getTranslation(lang);
  }

  getNgxMessagingTranslations(lang: string) {
    return this.httpClient.get(`${environment.assetsNgxMessaging}/i18n/${lang}.json`);
  }
}
